import React from "react";
import styled from "styled-components";

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  padding: 2rem;
  gap: 1.5rem;
`;

const ErrorIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: #dc2626;
`;

const ErrorTitle = styled.h2`
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
`;

const ErrorText = styled.p`
  color: #6b7280;
  font-size: 1rem;
  text-align: center;
  max-width: 500px;
  margin: 0;
  line-height: 1.6;
`;

const RetryButton = styled.button`
  background-color: #36b37e;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #00875a;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(54, 179, 126, 0.3);
  }
`;

type ErrorMessageProps = {
  title?: string;
  message?: string;
  onRetry?: () => void;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = "エラーが発生しました",
  message = "データの読み込みに失敗しました。しばらく経ってから再度お試しください。",
  onRetry,
}) => {
  return (
    <ErrorContainer>
      <ErrorIcon>⚠️</ErrorIcon>
      <ErrorTitle>{title}</ErrorTitle>
      <ErrorText>{message}</ErrorText>
      {onRetry && <RetryButton onClick={onRetry}>再試行</RetryButton>}
    </ErrorContainer>
  );
};
